import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return {
    mainContainer: {
      height: '100%',
      width: '100%',
      overflow: 'hidden',
    },
    sideBarContainer: {
      backgroundColor: `${theme.palette.KenColors.ClientRoyalPurple2} !important`,
      height: '100%',
      width: '100%',
      overflowX: 'hidden',
      overflowY: 'auto',
      boxShadow: 'none !important',
      borderRadius: '0px !important',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    logoContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center !important',
      justifyContent: 'space-between',
      paddingTop: '20px !important',
      padding: '15px !important',
      cursor: 'pointer',
    },
    logo: {
      height: '45px',
      cursor: 'pointer',
      [theme.breakpoints.down('fullHD')]: {
        height: '45px',
      },
    },
    logoTitle: {
      fontSize: '19px !important',
      fontWeight: '500 !important',
      [theme.breakpoints.down('ultraHD')]: {
        fontSize: '14px !important',
      },
    },
    sideBarIcon: {
      fontSize: '20px !important',
      color: theme.palette.KenColors.kenWhite,
      [theme.breakpoints.down('fullHD')]: {
        fontSize: '18px !important',
      },
      [theme.breakpoints.down('xxl')]: {
        fontSize: '14px !important',
      },
    },

    // tabs
    listItemIconActive: {
      color: theme.palette.KenColors.kenWhite,
      fontSize: '20px !important',
      [theme.breakpoints.down('fullHD')]: {
        fontSize: '19px !important',
      },
      [theme.breakpoints.down('xxl')]: {
        fontSize: '18px !important',
      },
    },
    listItemIcon: {
      color: theme.palette.KenColors.kenWhite,
      fontSize: '20px !important',
      [theme.breakpoints.down('fullHD')]: {
        fontSize: '19px !important',
      },
      [theme.breakpoints.down('xxl')]: {
        fontSize: '18px !important',
      },
    },
    listItemImgActive: {
      color: theme.palette.KenColors.kenWhite,
      height: '20px !important',
      [theme.breakpoints.down('fullHD')]: {
        height: '19px !important',
      },
      [theme.breakpoints.down('xxl')]: {
        height: '18px !important',
      },
    },
    listItemImg: {
      color: theme.palette.KenColors.kenWhite,
      height: '20px !important',
      [theme.breakpoints.down('fullHD')]: {
        height: '19px !important',
      },
      [theme.breakpoints.down('xxl')]: {
        height: '18px !important',
      },
    },

    listItemButtonActive: {
      background: `${theme.palette.KenColors.ClientRoyalpurple400} !important`,
      borderLeft: '4px solid #E6E6E6 !important',
    },
    nestedlistItemButtonActive: {
      background: `rgba(247, 236, 242, 0.10) !important`,
    },
    listItemButton: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingInline: '20px !important',
      [theme.breakpoints.down('fullHD')]: {
        paddingInline: '18px !important',
      },
      [theme.breakpoints.down('xxl')]: {
        paddingInline: '16px !important',
      },
      [theme.breakpoints.down('md')]: {
        paddingInline: '14px !important',
      },
    },
    listItemTextActive: {
      color: `${theme.palette.KenColors.kenWhite} !important`,
    },
    listItemText: {
      color: `${theme.palette.KenColors.ClientWhite2} !important`,
      fontSize: '16px !important',
      fontWeight: '500 !important',
      lineHeight: '22px !important',
      [theme.breakpoints.down('ultraHD')]: {
        fontSize: '14px !important',
      },
      [theme.breakpoints.down('fullHD')]: {
        fontSize: '12px !important',
      },
      [theme.breakpoints.down('xxl')]: {
        fontSize: '12px !important',
      },
      [theme.breakpoints.down('xl')]: {
        fontSize: '12px !important',
      },
      [theme.breakpoints.down('lg')]: {
        fontSize: '12px !important',
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '12px !important',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px !important',
      },
    },

    // header
    headerContainer: {
      height: '90px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingInline: '5px',
      [theme.breakpoints.down('ultraHD')]: {
        height: '80px !important',
      },
      [theme.breakpoints.down('fullHD')]: {
        height: '70px !important',
      },
      [theme.breakpoints.down('xxl')]: {
        height: '60px !important',
      },
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '30px',
      height: '70px !important',
      paddingInline: '20px',
      textAlign: 'start',

      boxShadow: 'none !important',
      [theme.breakpoints.down('ultraHD')]: {
        height: '100% !important',
        paddingInline: '18px',
      },
    },
    actions: {
      backgroundColor: `inherit !important`,
      display: 'flex',
      justifyContent: 'center',
      paddingInline: '10px',
      alignItems: 'center',
      borderRadius: '16px !important',
      gap: '10px',
      marginRight: '5px',
      boxShadow: 'none !important',
      [theme.breakpoints.down('md')]: {
        paddingInline: '5px',
        gap: '2px',
        marginRight: '1px',
      },
    },
    avatar: {
      width: '48px !important',
      height: '48px !important',
      borderRadius: '100px',
      objectFit: 'cover',
      color: theme.palette.KenColors.ClientBlue7,
      backgroundColor: theme.palette.KenColors.WhiteGray4,
      [theme.breakpoints.down('ultraHD')]: {
        width: '36px !important',
        height: '36px !important',
      },
      [theme.breakpoints.down('fullHD')]: {
        width: '32px !important',
        height: '32px !important',
      },
      [theme.breakpoints.down('xxl')]: {
        width: '28px !important',
        height: '28px !important',
      },
    },
    actionText: {
      whiteSpace: 'wrap',
      fontSize: '16px !important',
      fontWeight: '500 !important',
      color: theme.palette.KenColors.ClientBlack,
      [theme.breakpoints.down('ultraHD')]: {
        fontSize: '15px !important',
      },
      [theme.breakpoints.down('fullHD')]: {
        fontSize: '14px !important',
      },
      [theme.breakpoints.down('xxl')]: {
        fontSize: '14px !important',
      },
      [theme.breakpoints.down('lg')]: {
        fontSize: '14px !important',
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '12px !important',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '10px !important',
      },
    },

    // children
    childrenContainer: {
      height: `calc(100vh - 50px) !important`,
      width: '100% !important',
      overflow: 'hidden',
      [theme.breakpoints.down('xxl')]: {
        overflow: 'auto',
      },
    },

    // side bar
    sideBarSubContainer: {
      height: '100% !important',
      display: 'flex',
      flexDirection: 'column',
      flex: '1',
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    sideBarSubContainer1: {
      flex: '1',
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    headerText: {
      fontWeight: '600 !important',
      fontSize: '20px !important',
      color: theme.palette.KenColors.ClientBlack1,
      [theme.breakpoints.down('ultraHD')]: {
        fontSize: '18px !important',
        marginLeft: '-3px !important',
      },
      [theme.breakpoints.down('fullHD')]: {
        fontSize: '15px !important',
      },
      [theme.breakpoints.down('xxl')]: {
        fontSize: '14px !important',
      },
      [theme.breakpoints.down('xl')]: {
        fontSize: '14px !important',
      },
      [theme.breakpoints.down('lg')]: {
        fontSize: '12px !important',
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '10px !important',
      },
    },
    menuListItemButton: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'start',
      paddingInline: '0px !important',
    },
    menuListItemIcon: {
      fontSize: '24px !important',
      color: '#6A4EA6 !important',
    },
    menuListItemText: {
      color: `#333333 !important`,
      fontSize: '14px !important',
      fontWeight: '500 !important',
    },

    // mobile
    avatar3: {
      width: '64px !important',
      height: '64px !important',
      borderRadius: '100px',
      objectFit: 'cover',
      objectPosition: 'top',
      color: theme.palette.KenColors.ClientBlue7,
      backgroundColor: theme.palette.KenColors.WhiteGray4,
    },
    menuTitle: {
      color: '#333 !important',
      fontSize: '16px !important',
      fontWeight: '500',
      marginTop: '8px',
    },
    mobileHeaderContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    avatar2: {
      width: '32px !important',
      height: '32px !important',
      borderRadius: '100px',
      objectFit: 'cover',
      objectPosition: 'top',
      color: theme.palette.KenColors.ClientBlue7,
      backgroundColor: theme.palette.KenColors.WhiteGray4,
      border: '2px solid #604797',
    },
    icon: {
      height: '28px',
      width: '28px',
      color: '#8A8A8A',
    },
    // bottom navigation
    footerNav: {
      width: '100%',
      height: '100%',
      paddingBottom: '7px',
      position: 'fixed',
      bottom: 0,
      borderTop: '1px solid #F0EDF6',
      background: '#FFF',
    },
  };
});
